module.exports = __webpack_public_path__ + "static/img/45-1.3337e85.png";